import { ADMINISTRATE_PATH, isAdministrateWorkspace } from "./workspaceDisplay";
import { stopIntercom } from "./intercom";

export default function redirectToWorkspace(targetUser, { returnTo } = {}) {
  const isLocalHost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const hostParts = window.location.host.split(".");
  const host = isLocalHost
    ? window.location.host
    : [targetUser.company.subdomain, ...hostParts.slice(1)].join(".");
  const authTokenUrl = new URL(`${window.location.protocol}//${host}/auth/token`);
  authTokenUrl.searchParams.set("token", targetUser.token);
  const destination =
    returnTo || (isAdministrateWorkspace(targetUser.company) ? ADMINISTRATE_PATH : null);
  if (destination) {
    authTokenUrl.searchParams.set("returnTo", destination);
  }
  stopIntercom();
  window.location.href = authTokenUrl.toString();
}
